var _path, _path2, _line, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoEyeHide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4978 19.1538C16.9635 19.1538 18.9624 17.155 18.9624 14.6892C18.9624 12.2235 16.9635 10.2246 14.4978 10.2246C12.0321 10.2246 10.0332 12.2235 10.0332 14.6892C10.0332 17.155 12.0321 19.1538 14.4978 19.1538Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5552 13.4534C25.1234 9.30637 19.9285 5.31445 14.5001 5.31445C9.07055 5.31445 3.87447 9.30916 0.444926 13.4534C-0.148309 14.17 -0.148309 15.2103 0.444926 15.9268C1.30715 16.9688 3.11476 18.9801 5.529 20.7374C11.6092 25.1637 17.3776 25.1734 23.4711 20.7374C25.8854 18.9801 27.693 16.9688 28.5552 15.9268C29.1467 15.2117 29.1498 14.1723 28.5552 13.4534V13.4534ZM14.5001 8.43968C17.9468 8.43968 20.7505 11.2435 20.7505 14.6901C20.7505 18.1368 17.9468 20.9406 14.5001 20.9406C11.0534 20.9406 8.24962 18.1368 8.24962 14.6901C8.24962 11.2435 11.0534 8.43968 14.5001 8.43968Z",
    fill: "#999999"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.94922,
    y1: 25.5759,
    x2: 25.5258,
    y2: 3.9994,
    stroke: "#999999",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3.94922,
    y1: 27.6014,
    x2: 27.5494,
    y2: 4.00121,
    stroke: "#F9F9F8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEyeHide);
export default __webpack_public_path__ + "static/media/ico_eye_hide.beb377e22f53d25892f5d749a324c203.svg";
export { ForwardRef as ReactComponent };